import { useState, useEffect } from 'react'
import { usePageMeta } from '@/hooks/usePageMeta'
import ContactForm from './components/ContactForm'
import ContactInfo from './components/ContactInfo'
import { Settings } from '@/types'
import './Contact.css'

function Contact() {
  usePageMeta({
    title: 'Contact',
    description: 'Envoyez-nous un message, nous vous répondrons dans les plus brefs délais.',
  })

  const [settings, setSettings] = useState<Settings | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    fetchSettings()
  }, [])

  const fetchSettings = async () => {
    try {
      setLoading(true)
      const response = await fetch(`${import.meta.env.VITE_API_URL || 'http://localhost:8000/api'}/settings`)
      const data = await response.json()

      if (data.success && data.data) {
        setSettings(data.data)
      }
    } catch (error) {
      console.error('Error fetching settings:', error)
      // Continue even if settings fail to load
      setSettings(null)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="contact-container">
      <div className="contact-header">
        <h1>Nous contacter</h1>
        <p>Envoyez-nous un message, nous vous répondrons dans les plus brefs délais</p>
      </div>

      <div className="contact-content">
        <div className="contact-form-section">
          <ContactForm />
        </div>

        <div className="contact-info-section">
          {loading ? (
            <div className="contact-info-loading">
              <div className="spinner"></div>
              <p>Chargement des informations...</p>
            </div>
          ) : (
            <ContactInfo settings={settings || {}} />
          )}
        </div>
      </div>
    </div>
  )
}

export default Contact
